import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import esg_picture_body from '../../img/esg_picture_body.svg';
import { userContextActions } from '../../store/userContextStore';


class ESGSection extends React.Component {

    render() {
        return this.renderContent();
    }

    renderContent = () => {
        return (<>
            <div style={{ display: 'flex' }}>
                <div style={{ width: '35%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ height: '70%', verticalAlign: 'middle' }}>
                        <img alt="ESG image" width="250px" height="250px" src={esg_picture_body} style={{ height: '100%', verticalAlign: 'middle', objectFit: 'contain' }} />
                    </div>
                </div>
                <div style={{ width: '65%' }}>
                    <span className='title is-4' style={{ width: '70%', display: 'block', textAlign: 'center', marginBottom: '0.7em', marginTop: '2.5em' }}>CRIF ESG REPORTING</span>
                    <span className='title is-5' style={{ width: '70%', display: 'block', textAlign: 'center', marginBottom: '0.2em' }}><Translate id="Report.ESG.InfoText.Heading" options={{ renderInnerHtml: true }} /><br /><br />
                    </span><br />
                    <Translate id="Report.ESG.InfoText.First" options={{ renderInnerHtml: true }} /><br /><br />
                    <Translate id="Report.ESG.InfoText.Second" options={{ renderInnerHtml: true }} /><br /><br />
                    <Translate id="Report.ESG.InfoText.Third" options={{ renderInnerHtml: true }} />
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <a className='bb-button gradient-1' href={this.getLink()} target='_blank'><Translate id="Report.ESG.ButtonText" /></a>
            </div>
        </>)
    }

    getLink = () => {
        let agentLanguage = this.props.user.authentication.profile.agentLanguage;
        let currentLanguage = this.props.user.language;
        if (currentLanguage === "sk-SK") return "https://www.crif-esg.sk/zacat-s-esg/?utm_source=aplikacie&utm_medium=banner&utm_campaign=cribis"
        if (currentLanguage === "cs-CZ") return "https://www.crif-esg.cz/zacit-s-esg/?utm_source=aplikace&utm_medium=banner&utm_campaign=cribis"
        if (agentLanguage === 'sk-SK' && currentLanguage != "sk-SK") return "https://www3.cribis.sk/contact"

        return "https://www3.cribis.cz/contact";
    }
}

export default connect(
    state => { return { user: state.userContext } },
    dispatch => bindActionCreators(userContextActions, dispatch)
)(ESGSection);